<template>
  <input
    type="date"
    v-model="value"
    :class="['form-control', small ? 'form-control-sm' : '']"
    v-bind="$attrs"
  />
</template>

<script>
import { normalizeLicenseDay } from '@strenforcement/domain/licenseDates';

export default {
  props: {
    modelValue: [Object, String, Number],
    small: Boolean
  },
  emits: ['update:modelValue'],
  computed: {
    value: {
      get() {
        try {
          return normalizeLicenseDay(this.modelValue);
        } catch {
          return null;
        }
      },
      set(v) {
        this.$emit('update:modelValue', v || null);
      }
    }
  }
}
</script>
